import StaffListTable from './StaffListTable';

export default StaffListTable;
